// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__15ARV","list":"PatternAutocomplete_list__2AROd"};